import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
export default props => {
	useStyles(classes)
	const {image} = props
	return <img src={image} className={classes.FlyToCart}/>
}